import { createSelector } from 'reselect';
import { getWishId } from 'lib/commonSelectors';

const getEditWish = state => state.editWish;

export const getEditedWishId = createSelector(
  getEditWish,
  editWish => editWish.editedWishId
);

export const getIsEditingWish = createSelector(
  getEditedWishId,
  getWishId,
  (editedWishId, wishId) => editedWishId === wishId
);

export const getEditsForWishId = createSelector(
  getEditWish,
  getEditedWishId,
  (editWish, wishId) => editWish.edits[wishId]
);



// WEBPACK FOOTER //
// ./src/store/editWish/selectors.js